import React, { Component } from "react"
import ReactDOM from "react-dom"

export default class Loading extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="spinner">
      <div className="circle1"></div>
      <div className="circle2"></div>
    </div>
  }
}

export const LoaderCircle = () => <div className="loader--circle" />
